import { FileText, Receipt } from "lucide-react";

export default function QuotesList({ quotes, sending, onSendContract }) {
  return (
    <div data-testid="admin-quotes-list" className="flex flex-col gap-4">
      {quotes.length === 0 && <p style={{ color: "var(--text-secondary)" }}>No quote requests yet.</p>}
      {quotes.map((q) => (
        <div
          key={q.id}
          data-testid={`admin-quote-${q.id}`}
          className="rounded-2xl p-5 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4"
          style={{ backgroundColor: "#fff", border: "1px solid var(--border-light)" }}
        >
          <div className="text-sm" style={{ color: "var(--text-secondary)" }}>
            <div className="flex items-center gap-2 mb-1">
              <Receipt size={15} color="var(--rose-mocha)" />
              <span className="font-medium text-base" style={{ color: "var(--text-primary)" }}>{q.name}</span>
              <span
                className="text-xs px-2 py-0.5 rounded-full"
                style={{ backgroundColor: "#F3DAD5", color: "var(--rose-mocha-deep)" }}
              >
                {q.package}
              </span>
            </div>
            <p>{q.email}{q.phone && ` · ${q.phone}`}</p>
            {q.business && <p>Business: {q.business}</p>}
            {q.hours && <p>Hours needed / month: {q.hours}</p>}
            {q.details && <p className="mt-1 italic">"{q.details}"</p>}
          </div>
          <button
            data-testid={`admin-send-contract-quote-${q.id}`}
            onClick={() => onSendContract(q.name, q.email)}
            disabled={sending === q.email}
            className="shrink-0 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm disabled:opacity-60"
            style={{ backgroundColor: "var(--accent-gold)", color: "#2E241D" }}
          >
            <FileText size={15} /> {sending === q.email ? "Sending…" : "Send Contract"}
          </button>
        </div>
      ))}
    </div>
  );
}
